export default "__VITE_ASSET__D4HYsvDw__"